import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../headerone/Main'
import { Row, Col } from 'react-bootstrap';
import Committeeleft from './Committeeleft';
import Breadcrumb from '../../Breadcrumb/Main'
import { Table } from 'react-bootstrap';



function StatementExpenELe() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Liaison Officers" />
            <section id="services" className="team-area fix p-relative pt-120 pb-80">
            <div className="container">
            <Row>
            <Col md={3} className='c-left custom-padding-color mb-4'>
                  <Committeeleft></Committeeleft>
            </Col>
                
             <Col md={9} className='c-right'>
                       
                    <div className="row">
                
                        <div className="col-lg-12">
                            <div className="section-title text-center mb-50 wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s" >
                                <h3>SC/ST Cell</h3>
                            </div>
                        </div>
                    </div>


                    <div className="row"> 
                        <div className="col-lg-12 col-md-12">
                            <div className="services-box text-dark ">
                                <h3><p>Liaison Officer for SC/ST </p></h3>
                                <p>Dr. Gowri Asaithambi </p>
                                <p>Associate Professor </p>
                                <p className="text-dark "><i className="fal fa-phone-alt me-2"></i> 0877 250 3158 </p>                                
                                <p className="text-dark text-maroon"><i className="fal fa-envelope  me-2"></i><Link className='text-teal' target="_blank"  to="gowri@iittp.ac.in"> gowri@iittp.ac.in</Link> </p>
                                           
                                <Table bordered responsive className='mt-3'>
                                    <tbody>
                    
                                        <tr>
                                            <td>
                                                <p>Dr. Jayanarayan Thakurdas Tudu</p>
                                                <p>Assistant Professor </p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. Nilesh Choudhary</p>
                                                <p>Assistant Professor</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Mrs. Sandhya Yellapragada</p>
                                                <p>Section Officer</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Mr. Shubham Ahirwar</p>
                                                <p>ME21B043</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Ms. Sangita Singh</p>
                                                <p>HS23D507</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Mr. M Venkat Ramana</p>
                                                <p>Assistant Registrar</p>
                                            </td>
                                            <td>Member Secretary</td>
                                        </tr>
                                    </tbody>

                                </Table>                                
                            </div>
                            
                        </div>

                        


                    </div>  {/* Row */}


                    <div className="row mt-4">
                        <div className="col-lg-12">
                            <div className="section-title text-center mb-50 wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s" >
                                <h3>OBC Cell</h3>
                            </div>
                        </div>
                    </div>

                    <div className="row"> 
                       

                        <div className="col-lg-12 col-md-12">
                            <div className="services-box text-dark ">
                                <h3><p>Liaison Officer for OBC  </p></h3>
                                <p>Dr. N. Venkaiah</p>
                                <p>Professor </p>
                                <p className="text-dark "><i className="fal fa-phone-alt me-2"></i> 0877 250 3035 </p>
                                <p className="text-dark text-maroon"><i className="fal fa-envelope  me-2"></i><Link className='text-teal' target="_blank"  to="venkaiah@iittp.ac.in">venkaiah@iittp.ac.in</Link> </p>
                                <Table bordered responsive className='mt-3'>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <p>Dr. M Nithyadharan</p>
                                                <p>Associate Professor </p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. Bibhuti Mary Kachhap</p>
                                                <p>Assistant Professor</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Mrs. A K Suresh</p>
                                                <p>Junior Technical Superintendent</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Ms. Sneha S</p>
                                                <p>PH22D503</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Mr. Umesh Kumar Singh</p>
                                                <p>Assistant Registrar</p>
                                            </td>
                                            <td>Member Secretary</td>
                                        </tr>
                                    </tbody>

                                </Table>
                            
                            </div>
                        </div>
                        


                    </div> 

                   
                       


                
                </Col>
            </Row>
            </div>   {/* container */}
            </section>
        </>  
    )
}

export default StatementExpenELe;
